export default __webpack_public_path__ + "static/rf-kiln-7943a2e0b777e2341bc5b2c04f9d99b9.mp4";